module.exports = __webpack_public_path__ + "static/media/восстановление.46f2f467.jpg";